import {Component, OnInit, ViewChild} from '@angular/core';
import {MatPaginator} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import {MatTableDataSource} from '@angular/material/table';
import {CommonService} from '../../services/common.service';
import {ExcelService} from '../../services/excel.service';
import {ReportService} from '../../services/report.service';
import {ToastMessagesService} from '../../services/toast-messages.service';

@Component({
  selector: 'app-login-attempts',
  templateUrl: './login-attempts.component.html',
  styleUrls: ['./login-attempts.component.scss']
})
export class LoginAttemptsComponent implements OnInit {
  columnsToDisplay: any = ['name', 'action_date', 'action'];
  dataSource: MatTableDataSource<any> = new MatTableDataSource<any>();
  isLoading: boolean;
  pageTitle = 'Προσπάθειες εισόδου στο eApply';
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  @ViewChild(MatSort, {static: true}) sort: MatSort;
  constructor(public toastMessagesService: ToastMessagesService,
              private commonService: CommonService,
              public excelService: ExcelService,
              private reportsService: ReportService) {
    this.isLoading = false;
  }

  async ngOnInit() {
    try {
      const records = await this.reportsService.getLoginAttempts();
      this.dataSource = new MatTableDataSource<any>(records);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
      this.commonService.setPaginatorTexts(this.paginator);
    } catch (e) {
      this.toastMessagesService.toastErrorMessage('Δεν μπορέσαμε να ολοκληρώσουμε το αίτημά σας');
    }
  }

  exportToExcel() {
    const {records, columns} = this.formatModel();
    this.excelService.exportAsCustomExcelFile(records, 'Ενέργειες εισόδου', columns);
  }

  search(value: any) {
    const searchValue = value.toLowerCase().trim();
    this.dataSource.filter = searchValue;
  }

  formatModel() {
    const records = [];
    for (const record of this.dataSource.data) {
      const model = {
        name: record.name,
        action_date: record.action_date_time,
        action: record.action,
        action_description: record.action_description
      };
      records.push(model);
    }

    const columns = [{
      key: 'name',
      label: 'Αναγνωριστικό',
    },
      {
        key: 'action_date',
        label: 'Ημερομηνία ενέργειας',
      },
      {
        key: 'action',
        label: 'Ενέργεια',
      },
      {
        key: 'action_description',
        label: ' Περιγραφή ενέργειας',
      }];

    return {records, columns};
  }
}
